__turbopack_context__.v({
  "list": "styles-module__TcCgqW__list",
});
